import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const createBooking = (payload) =>
  axios.post(`${API}/bookings`, payload).then((r) => r.data);

export const createAssessment = (payload) =>
  axios.post(`${API}/assessments`, payload).then((r) => r.data);
